import Madison1 from '../../media/Madison/madison (1).png'
import Madison2 from '../../media/Madison/madison (2).png'
import Madison3 from '../../media/Madison/madison (3).png'
import Madison4 from '../../media/Madison/madison (4).png'
import Madison5 from '../../media/Madison/madison (5).png'
import Madison6 from '../../media/Madison/madison (6).png'
import Madison7 from '../../media/Madison/madison (7).png'
import Madison8 from '../../media/Madison/madison (8).png'
import Madison9 from '../../media/Madison/madison (9).png'

const images =[
    Madison1,Madison2,Madison3,Madison4,Madison5,Madison6,Madison7,Madison8,Madison9
]

export default images;